module.exports = __webpack_public_path__ + "static/media/opration1.bcf3ae7f.avif";